import React, { useState, useEffect } from "react";
import { storeRequestCallback, fetchAllSpecialities, fetchFilterOPD } from "../Adapter/PageAdapter";
import { toast } from "sonner";
import newArrImg from "../assets/images/arrw.svg";

const initialFormData = {
    patientName: "",
    contactNo: "",
    email: "",
    speciality_id: "",
    doctor_id: "",
    date: "",
    message: "",
};

// Request A Call Back form shown on the blog detail page (same fields & submit flow as the header modal)
const BlogCallbackForm = () => {
    const [formData, setFormData] = useState(initialFormData);
    const [specialties, setSpecialties] = useState([]);
    const [doctorsList, setDoctorsList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchSpecialties = async () => {
            try {
                const response = await fetchAllSpecialities();
                if (response && response.specialities) {
                    setSpecialties(response.specialities);
                }
            } catch (error) {
                console.error("Error fetching specialties:", error);
            }
        };
        fetchSpecialties();
    }, []);

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        // Only allow numbers and plus in contactNo
        if (name === "contactNo") {
            const sanitizedValue = value.replace(/(?!^)\+/g, "").replace(/[^0-9+]/g, "");
            setFormData({ ...formData, [name]: sanitizedValue });
            return;
        }

        setFormData({ ...formData, [name]: value });
    };

    // Fetch doctors when a specialty is selected
    const handleSpecialtyList = async (e) => {
        const specialityId = e.target.value;
        setFormData({
            ...formData,
            speciality_id: specialityId,
            doctor_id: "",
        });

        try {
            const response = await fetchFilterOPD(specialityId);
            if (response && response.data) {
                setDoctorsList(response.data);
            } else {
                setDoctorsList([]);
            }
        } catch (error) {
            console.error("Error fetching doctors:", error);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (loading) return;

        setLoading(true);

        const selectedDoctor = doctorsList.find(
            (doc) => parseInt(doc.doctor_id) === parseInt(formData.doctor_id)
        );
        const selectedSpeciality = specialties.find(
            (spec) => parseInt(spec.id) === parseInt(formData.speciality_id)
        );

        const payload = {
            patient_name: formData.patientName,
            contact_number: formData.contactNo,
            email: formData.email,
            // Tag the lead source so blog leads can be identified in the DB
            message: formData.message.trim() ? `${formData.message.trim()} | Blog` : "Blog",
            appointment_date: formData.date,
            speciality_id: formData.speciality_id,
            doctor_id: formData.doctor_id,
            doctor_name: selectedDoctor?.doctor_name || "",
            speciality_name: selectedSpeciality?.name || "",
        };

        try {
            // "| Blog" tag is for the DB only; CRM gets the user's remarks as typed
            await storeRequestCallback(payload, { message: formData.message.trim() });
            toast.success("Request submitted successfully!");
            setFormData(initialFormData);
            setDoctorsList([]);
        } catch (error) {
            console.error("Submission error:", error);
            toast.error("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="intern-form-inner blog-callback-form">
            <h5>Request A Call Back</h5>
            <form onSubmit={handleSubmit}>
                <div className="int-form-item">
                    <label htmlFor="blogPatientName">
                        Full Name of the Patient <span>*</span>
                    </label>
                    <input
                        type="text"
                        id="blogPatientName"
                        name="patientName"
                        value={formData.patientName}
                        onChange={handleInputChange}
                        required
                    />
                </div>
                <div className="int-form-item">
                    <label htmlFor="blogContactNo">
                        Contact No <span>*</span>
                    </label>
                    <input
                        type="text"
                        id="blogContactNo"
                        name="contactNo"
                        value={formData.contactNo}
                        onChange={handleInputChange}
                        pattern="^\+?[0-9]*$"
                        maxLength={15}
                        required
                    />
                </div>
                <div className="int-form-item">
                    <label htmlFor="blogEmail">Email</label>
                    <input
                        type="email"
                        id="blogEmail"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                    />
                </div>
                <div className="int-form-item">
                    <label htmlFor="blogSpeciality">Speciality <span>*</span></label>
                    <select
                        id="blogSpeciality"
                        name="speciality"
                        value={formData.speciality_id}
                        onChange={handleSpecialtyList}
                        required
                    >
                        <option value="">Please select Speciality</option>
                        {specialties.map((specialty) => (
                            <option key={specialty.id} value={specialty.id}>
                                {specialty.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="int-form-item">
                    <label htmlFor="blogDoctor">Select Doctor <span>*</span></label>
                    <select
                        id="blogDoctor"
                        name="doctor_id"
                        value={formData.doctor_id}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Please select Doctor</option>
                        {doctorsList.map((doctor) => (
                            <option key={doctor.doctor_id} value={doctor.doctor_id}>
                                {doctor.doctor_name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="int-form-item">
                    <label htmlFor="blogDate">Please Select Date <span>*</span></label>
                    <input
                        type="date"
                        id="blogDate"
                        name="date"
                        value={formData.date}
                        onChange={handleInputChange}
                        min={new Date().toISOString().split("T")[0]}
                        required
                    />
                </div>
                <div className="int-form-item">
                    <label htmlFor="blogMessage">Remarks</label>
                    <textarea
                        id="blogMessage"
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows="3"
                    ></textarea>
                </div>
                <div className="int-form-item">
                    <button type="submit" disabled={loading}>
                        {loading ? (
                            <>
                                <img src={newArrImg} alt="" className="spin" />
                                Sending...
                            </>
                        ) : (
                            <>
                                <img src={newArrImg} alt="" />
                                Submit
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default BlogCallbackForm;
